export default __webpack_public_path__ + "static/media/donauP.04696afa.jpg";